import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Avatar } from 'antd'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const CONSTITUENT_AVATAR = gql`
    query constituentAvatar(
		$constituent_uid: String
	) {
		constituentAvatar(
			constituent_uid: $constituent_uid
		)
    }
`

const ConstituentAvatar = (props) => {
	const { 
		client, constituent_uid, ...rest 
	} = props

	return (
		
		<Query 
			query={CONSTITUENT_AVATAR}
			variables={{ constituent_uid }}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const constituentAvatar = _.has(data, 'constituentAvatar') ? data.constituentAvatar : null
				//console.log('userAvatar', userAvatar)
				const avatarUrl = _.has(constituentAvatar, 'url') ? 
					`${process.env.REACT_APP_BACKEND_API}${constituentAvatar.url}` 
					: 'https://i.ya-webdesign.com/images/avatar-png-3.png'
				return (
					<Avatar { ...rest } icon="user" src={avatarUrl} />
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(ConstituentAvatar)